
export default function AboutHero() {
  return (
    <section className="relative bg-gradient-to-br from-blue-600 to-purple-700 text-white py-20">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-6xl font-bold mb-6">
          About Marketing Ads
        </h1>
        <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto">
          Building trust and connection with our clients through performance-driven marketing strategies
        </p>
      </div>
    </section>
  );
}
